import { NgModule } from '@angular/core';
import { RouterModule, Routes, NoPreloading } from '@angular/router';
import { environment } from '@enviroment/environment';
import { HomeV2Component } from './routes/home-v2/home-v2.component';
import { getBestCdtMonthRoutes, getOldBestCdtMonthRoutes } from '@utils/routing/best-cdt-month-routes.util';
import { routingColtefinanciera } from '@utils/routing/brand/coltefinanciera/routing.routes';
import { CustomPreloadingStrategy } from '@utils/custom-preloading.strategy';
import { flowRouteSeo } from '@utils/routing/flow-routes-seo.config';
import { AuthSessionGuard } from '@core/guards/auth-session.guard';
import { ProcessRouteGuard } from '@core/guards/process-route.guard';
import {
  COMPLETED_STATUSES,
  DEPOSIT_STATUSES,
  DOCUMENT_UPLOAD_STATUSES,
  LEAD_FORM_STATUSES,
  SIGNING_STATUSES,
} from '@services/process-route/process-route.constants';

const PROCESS_ROUTE_GUARDS = [AuthSessionGuard, ProcessRouteGuard];
const PROCESS_AUTH_GUARDS = [AuthSessionGuard];

const routes_app: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./routes/home/home.module').then((m) => m.HomeModule),
  },

  {
    path: 'ahorro',
    loadComponent: () => import('./routes/ahorro/pages/ahorro/ahorro.component').then((m) => m.AhorroComponent),
  },

  {
    path: 'cdt-simulador',
    loadChildren: () => import('./routes/cdt-simulador-v2/cdt-simulador-v2.module').then((m) => m.CdtSimuladorV2Module),
  },

  /* {
    path: 'hoy-los-bancos-ofrecen',
    loadChildren: () =>
      import('./routes/hoy-los-bancos-ofrecen/hoy-los-bancos-ofrecen.module').then((m) => m.HoyLosBancosOfrecenModule),
  }, */

  {
    path: 'hoy-los-bancos-ofrecen',
    loadComponent: () =>
      import('./routes/hoy-los-bancos-ofrencen-v2/hoy-los-bancos-ofrecen-v2.component').then(
        (m) => m.HoyLosBancosOfrecenV2Component,
      ),
  },
  {
    path: 'pauta/remarketing/hoy-los-bancos-ofrecen',
    loadComponent: () =>
      import('./routes/hoy-los-bancos-ofrencen-v2/hoy-los-bancos-ofrecen-v2.component').then(
        (m) => m.HoyLosBancosOfrecenV2Component,
      ),
  },
  {
    path: 'pauta/llamada/hoy-los-bancos-ofrecen',
    loadComponent: () =>
      import('./routes/hoy-los-bancos-ofrencen-v2/hoy-los-bancos-ofrecen-v2.component').then(
        (m) => m.HoyLosBancosOfrecenV2Component,
      ),
  },
  {
    path: 'pauta/control/hoy-los-bancos-ofrecen',
    loadComponent: () =>
      import('./routes/hoy-los-bancos-ofrencen-v2/hoy-los-bancos-ofrecen-v2.component').then(
        (m) => m.HoyLosBancosOfrecenV2Component,
      ),
  },

  {
    path: 'quienes-somos',
    redirectTo: '/sobre-nosotros#sobre-nosotros-what-is-mejorcdt-aside',
    pathMatch: 'full',
  },

  {
    path: 'como-lo-hacemos',
    redirectTo: '/sobre-nosotros#sobre-nosotros-steps-scroll-standalone-aside',
    pathMatch: 'full',
  },

  {
    path: 'declaracion-de-renta-sin-contratiempos',
    loadComponent: () =>
      import('./routes/declaracion-de-renta-sin-contratiempos/declaracion-de-renta-sin-contratiempos.component').then(
        (m) => m.DeclaracionDeRentaSinContratiemposComponent,
      ),
  },

  {
    path: 'que-es-un-cdt-y-como-funciona',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'que-es-un-cdt-y-como-funciona',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'como-abrir-un-cdt',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'como-abrir-un-cdt',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'como-elegir-el-mejor-plazo-para-mi-cdt',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'como-elegir-el-mejor-plazo-para-mi-cdt',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'que-es-fogafin-y-como-protege-mi-cdt',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'que-es-fogafin-y-como-protege-mi-cdt',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'para-que-mas-sirve-un-cdt-ademas-de-ahorrar',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'para-que-mas-sirve-un-cdt-ademas-de-ahorrar',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'los-cdt-son-seguros',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'los-cdt-son-seguros',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'mejores-tasas-de-cdt-en-colombia-septiembre-2026',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'mejores-tasas-de-cdt-en-colombia-septiembre-2026',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'mejores-cdt-a-12-meses-en-colombia-2026',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'mejores-cdt-a-12-meses-en-colombia-2026',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'mejores-tasas-de-cdt-en-colombia-octubre-2026',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'mejores-tasas-de-cdt-en-colombia-octubre-2026',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'como-invertir-100-millones-en-colombia-con-bajo-riesgo',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'como-invertir-100-millones-en-colombia-con-bajo-riesgo',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'como-calcular-la-rentabilidad-de-un-cdt',
    loadComponent: () => import('./routes/ai/ai-article.component').then((m) => m.AiArticleComponent),
    data: {
      aiArticleSlug: 'como-calcular-la-rentabilidad-de-un-cdt',
      seo: {
        articleSection: 'AI Visibility',
      },
    },
  },

  {
    path: 'especial-convencion-bancaria-asobancaria-2026',
    loadComponent: () =>
      import(
        './routes/especial-convencion-bancaria-asobancaria-2026/especial-convencion-bancaria-asobancaria-2026.component'
      ).then((m) => m.EspecialConvencionBancariaAsobancaria2026Component),
    data: {
      aiArticleSlug: 'especial-convencion-bancaria-asobancaria-2026',
      seo: {
        articleSection: 'Convención Bancaria Asobancaria 2026',
      },
    },
  },

  {
    path: 'el-ahorro-en-colombia-no-rendia-asi-hace-anos',
    loadComponent: () =>
      import(
        './routes/el-ahorro-en-colombia-no-rendia-asi-hace-anos/el-ahorro-en-colombia-no-rendia-asi-hace-anos.component'
      ).then((m) => m.ElAhorroEnColombiaNoRendiaAsiHaceAnosComponent),
    data: {
      aiArticleSlug: 'el-ahorro-en-colombia-no-rendia-asi-hace-anos',
      seo: {
        articleSection: 'El ahorro en Colombia no rendía así hace años',
      },
    },
  },

  {
    path: 'sobre-nosotros',
    loadComponent: () =>
      import('./routes/sobre-nosotros/sobre-nosotros.component').then((m) => m.SobreNosotrosComponent),
  },

  {
    path: 'por-que-comparar',
    redirectTo: '/sobre-nosotros#sobre-nosotros-cdt-comparison-aside',
    pathMatch: 'full',
  },

  {
    path: 'contactanos',
    loadChildren: () => import('./routes/contactenos/contactenos.module').then((m) => m.ContactenosModule),
  },

  {
    path: 'verificando-firma',
    loadChildren: () =>
      import('./routes/verificado-firma/verificado-firma.module').then((m) => m.VerificadoFirmaModule),
  },

  {
    path: 'ops/dashboard',
    loadChildren: () => import('./routes/ops/ops.module').then((m) => m.OpsModule),
  },

  {
    path: 'portal',
    loadChildren: () => import('./routes/portal/portal.module').then((m) => m.PortalModule),
    data: { seo: flowRouteSeo.PortalModule },
  },

  {
    path: '4B6XN8K2H7VY3W9M5Q1Z9A3JN7M5D1H8S4L0F2K',
    loadChildren: () => import('./routes/modo-dios/modo-dios.module').then((m) => m.ModoDiosModule),
  },

  {
    path: 'app',
    children: [
      {
        path: '',
        loadChildren: () => import('./routes/app/app.module').then((m) => m.AppModule),
      },
      {
        path: '**',
        redirectTo: '/app',
        pathMatch: 'full',
      },
    ],
  },

  {
    path: 'tratamientos-datos-personales-banco-w',
    loadChildren: () =>
      import('./routes/legal/pages/term-conditions-bancow/term-conditions-bancow.module').then(
        (m) => m.TermConditionsBancowModule,
      ),
  },

  {
    path: 'legal/mundial-de-tejo-2025',
    loadComponent: () =>
      import('./routes/legal/pages/legal-mundial-de-tejo-2025/legal-mundial-de-tejo-2025.component').then(
        (m) => m.LegalMundialDeTejo2025Component,
      ),
  },

  {
    path: 'legal/finverzo-2025',
    loadComponent: () =>
      import('./routes/legal/pages/legal-finverzo-2025/legal-finverzo-2025.component').then(
        (m) => m.LegalFinverzo2025Component,
      ),
  },

  {
    path: 'legal/fintrust-2025',
    loadComponent: () =>
      import('./routes/legal/pages/legal-fintrust-2025/legal-fintrust-2025.component').then(
        (m) => m.LegalFintrust2025Component,
      ),
  },

  {
    path: 'legal/yo-me-llamo-cdt',
    loadComponent: () =>
      import('./routes/legal/pages/legal-yo-me-llamo-cdt/legal-yo-me-llamo-cdt.component').then(
        (m) => m.LegalYoMeLlamoCdtComponent,
      ),
  },
  {
    path: 'legal/moneymastery-2025',
    loadComponent: () =>
      import('./routes/legal/pages/terminos-condiciones-moneymonastery/terminos-condiciones-moneymonastery.component').then(
        (m) => m.LegalTerminosCondicionesMoneyMonastery,
      ),
  },
  {
    path: 'legal/circombia',
    loadComponent: () =>
      import('./routes/legal/pages/terminos-condiciones-circombia/terminos-condiciones-circombia.component').then(
        (m) => m.TerminosCondicionesCircombiaComponent,
      ),
  },
  {
    path: 'legal/juntos-podemos-ayudar',
    loadComponent: () =>
      import('./routes/legal/pages/terminos-condiciones-juntos-podemos-ayudar/terminos-condiciones-juntos-podemos-ayudar.component').then(
        (m) => m.TerminosCondicionesJuntosPodemosAyudarComponent,
      ),
  },
  {
    path: 'legal/ponle-nombre-a-tu-ahorro',
    loadComponent: () =>
      import('./routes/legal/pages/terminos-condiciones-ponle-nombre-a-tu-ahorro/terminos-condiciones-ponle-nombre-a-tu-ahorro.component').then(
        (m) => m.TerminosCondicionesPonleNombreATuAhorroComponent,
      ),
  },
  {
    path: 'legal/bonos/bono-de-bienvenida',
    loadComponent: () =>
      import('./routes/legal/pages/bonos/legal-bono-bienvenida.component').then((m) => m.LegalBonoBienvenidaComponent),
  },

  {
    path: 'legal/bonos/bono-escalonado',
    loadComponent: () =>
      import('./routes/legal/pages/bonos/legal-bono-escalonado.component').then((m) => m.LegalBonoEscalonadoComponent),
  },

  {
    path: 'legal/bonos/bono-porcentual',
    loadComponent: () =>
      import('./routes/legal/pages/bonos/legal-bono-porcentual.component').then((m) => m.LegalBonoPorcentualComponent),
  },

  {
    path: 'legal/bonos/cdt-regalo',
    loadComponent: () =>
      import('./routes/legal/pages/bonos/legal-cdt-regalo.component').then((m) => m.LegalCdtRegaloComponent),
  },

  {
    path: 'legal/bono/dias-azules',
    loadComponent: () =>
      import('./routes/legal/pages/bonos/legal-bono-dias-azules.component').then((m) => m.LegalBonoDiasAzulesComponent),
  },

  {
    path: 'legal/bono/moneycon-2026',
    loadComponent: () =>
      import('./routes/legal/pages/bonos/legal-bono-moneycon-2026.component').then(
        (m) => m.LegalBonoMoneycon2026Component,
      ),
  },

  {
    path: 'legal/bono/indice-arrepentimiento-financiero-2026',
    loadComponent: () =>
      import('./routes/legal/pages/bonos/legal-bono-iaf-2026.component').then((m) => m.LegalIAF2026Component),
  },

  {
    path: 'legal/cdtfuturo',
    loadChildren: () =>
      import('./routes/legal/pages/term-conditions-cdtfuturo/legal-cdtfuturo.module').then(
        (m) => m.LegalCdtfuturoModule,
      ),
  },

  {
    path: 'legal/bancamia',
    loadChildren: () =>
      import('./routes/legal/pages/terms-conditions-bancamia/legal-bancamia.module').then((m) => m.LegalBancamiaModule),
  },

  {
    path: 'legal/coltefinanciera',
    loadChildren: () =>
      import('./routes/legal/pages/terms-conditions-coltefinanciera/legal-coltefinanciera.module').then(
        (m) => m.LegalColtefinancieraModule,
      ),
  },

  {
    path: 'legal/mibanco',
    loadChildren: () =>
      import('./routes/legal/pages/terms-conditions-mibanco/legal-mibanco.module').then((m) => m.LegalMibancoModule),
  },
  {
    path: 'legal/bono-regalo',
    loadChildren: () =>
      import('./routes/legal/pages/terms-conditions-bonoregalo/terms-conditions-bonoregalo.module').then(
        (m) => m.TermsConditionsBonoregaloModule,
      ),
  },
  {
    path: 'legal/cdt-cupido',
    loadChildren: () =>
      import('./routes/legal/pages/term-condition-cdtcupido/term-condition-cdtcupido.module').then(
        (m) => m.TermConditionCdtcupidoModule,
      ),
  },
  {
    path: 'legal/terminos-cdtazo',
    loadChildren: () =>
      import('./routes/legal/pages/term-conditions-cdtazo/term-condition-cdtazo.module').then(
        (m) => m.TermConditionCdtazoModule,
      ),
  },
  {
    path: 'legal/koa',
    loadChildren: () =>
      import('./routes/legal/pages/term-conditions-koa/legal-koa.module').then((m) => m.LegalKoaModule),
  },

  {
    path: 'legal/vende-tu-cdt',
    loadComponent: () =>
      import('./routes/legal/pages/legal-compra-venta-cdt/legal-compra-venta-cdt.component').then(
        (m) => m.LegalCompraVentaCdtComponent,
      ),
  },

  {
    path: 'legal/terminos-y-condiciones-cdt-flexible-y-compra-de-cdt',
    loadComponent: () =>
      import('./routes/legal/pages/terminos-condiciones-cdt/terminos-condiciones-cdt.component').then(
        (m) => m.TerminosCondicionesCdtComponent,
      ),
  },

  {
    path: 'login',
    loadChildren: () => import('./routes/login/login.module').then((m) => m.LoginModule),
  },

  {
    path: 'mis-procesos',
    loadChildren: () => import('./routes/mis-procesos/mis-procesos.module').then((m) => m.MisProcesosModule),
  },

  {
    path: 'mejores-bancos-para-cdt-hoy',
    loadComponent: () =>
      import('./routes/mejores-bancos-para-cdt-hoy-v2/component/mejores-bancos-para-cdt-hoy-v2/mejores-bancos-para-cdt-hoy-v2.component').then(
        (m) => m.MejoresBancosParaCdtHoyV2Component,
      ),
  },

  /* {
    path: 'mejores-bancos-para-cdt-hoy',
    loadChildren: () =>
      import('./routes/old-mejores-bancos-para-cdt-hoy-v2/mejores-bancos-para-cdt-hoy-v2.module').then(
        (m) => m.MejoresBancosParaCdtHoyV2Module,
      ),
  }, */

  {
    path: 'mejores-tasas-para-cdt-hoy',
    loadComponent: () =>
      import('./routes/mejores-tasas-para-cdt-hoy/mejores-tasas-para-cdt-hoy.component').then(
        (m) => m.MejoresTasasParaCdtHoyComponent,
      ),
  },

  {
    path: 'sitemap',
    loadChildren: () => import('./utils/sitemap/sitemap.module').then((m) => m.SitemapModule),
  },

  {
    path: 'referidos',
    loadChildren: () => import('./routes/referidos/referidos.module').then((m) => m.ReferidosModule),
  },

  // {
  //   path: 'cdt-turbo',
  //   loadChildren: () => import('./routes/turbo/turbo.module').then((m) => m.TurboModule),
  // },

  {
    path: 'facil-cdt',
    loadChildren: () => import('./routes/turbo/turbo.module').then((m) => m.TurboModule),
  },

  {
    path: 'club-cdt',
    loadChildren: () => import('./routes/club-cdt/club-cdt.module').then((m) => m.ClubCdtModule),
  },

  {
    path: 'app/:any',
    redirectTo: 'app',
  },
];

const routes_ab_testing = [
  {
    path: 'ab-testing',
    loadChildren: () => import('./routes/ab-testing/ab-testing.module').then((m) => m.AbTestingModule),
  },

  // {
  //   path: 'ab-testing/cdt-simulador',
  //   loadChildren: () => import('./routes/cdt-simulador-v2/cdt-simulador-v2.module').then( m => m.CdtSimuladorV2Module)
  // },
];

const routes_campaign_mejorcdt = [
  {
    path: 'cdt-cupido',
    loadChildren: () => import('./routes/cdt-cupido/cdt-cupido.module').then((m) => m.CdtCupidoModule),
  },
];

const routes_form_sdk_tripetto = [
  {
    path: 'orden-inversion',
    canActivate: PROCESS_AUTH_GUARDS,
    loadChildren: () => import('./routes/tripetto-sdk/o-inversion/o-inversion.module').then((m) => m.OInversionModule),
  },
  {
    path: 'cancelacion',
    canActivate: PROCESS_AUTH_GUARDS,
    loadChildren: () =>
      import('./routes/tripetto-sdk/o-cancelacion/o-cancelacion.module').then((m) => m.OCancelacionModule),
  },
  {
    path: 'datos-personales',
    redirectTo: 'v2/datos-personales',
  },
  {
    path: 'datos-financieros',
    redirectTo: 'v2/datos-financieros',
  },
  {
    path: 'preguntas-ban100',
    redirectTo: 'v2/preguntas-ban100',
  },
  {
    path: 'preguntas-bancamia',
    redirectTo: 'v2/preguntas-bancamia',
  },
  {
    path: 'preguntas-bancow',
    redirectTo: 'v2/preguntas-bancow',
  },
  {
    path: 'preguntas-coltefinanciera',
    redirectTo: 'v2/preguntas-coltefinanciera',
  },
  {
    path: 'preguntas-iris',
    redirectTo: 'v2/preguntas-iris',
  },
  {
    path: 'preguntas/coltefinanciera/flamingo',
    redirectTo: 'v2/preguntas/coltefinanciera/flamingo',
  },
  {
    path: 'preguntas-mibanco',
    redirectTo: 'v2/preguntas-mibanco',
  },
  {
    path: 'preguntas-bancomundomujer',
    redirectTo: 'v2/preguntas-bancomundomujer',
  },
  {
    path: 'preguntas-credifamilia',
    redirectTo: 'v2/preguntas-credifamilia',
  },
  {
    path: 'preguntas-cdturbo',
    redirectTo: 'v2/preguntas-cdturbo',
  },
];

const routes_form_v2: Routes = [
  {
    path: 'cuentanos-sobre-ti',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/magical-experience/formulario/magical-experience.component').then(
        (m) => m.MagicalExperienceComponent,
      ),
    data: {
      seo: flowRouteSeo.cuentanosSobreTi,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
      processStep: 'about-you',
    },
  },
  {
    path: 'v2/datos-personales',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/datos-personales/datos-personales.module').then(
        (m) => m.DatosPersonalesModule,
      ),
    runGuardsAndResolvers: 'always',
    data: {
      onSameUrlNavigation: 'reload',
      seo: flowRouteSeo.datosPersonales,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'validacion-interna-proceso',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/process-restrictions/internal-validation/internal-validation.component').then(
        (m) => m.InternalValidationComponent,
      ),
    data: {
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-waiting'],
    },
  },
  {
    path: 'informacion-en-revision',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/process-restrictions/restricted-information/restricted-information.component').then(
        (m) => m.RestrictedInformationComponent,
      ),
    data: {
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-blocked'],
    },
  },
  {
    path: 'v2/datos-financieros',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/datos-financieros/datos-financieros.module').then(
        (m) => m.DatosFinancierosModule,
      ),
    data: {
      onSameUrlNavigation: 'reload',
      seo: flowRouteSeo.datosFinancieros,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'v2/preguntas-ban100',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-ban100/preguntas-ban100.module').then(
        (m) => m.PreguntasBan100Module,
      ),
    data: { seo: flowRouteSeo.preguntasBan100, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-bancamia',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-bancamia/preguntas-bancamia.module').then(
        (m) => m.PreguntasBancamiaModule,
      ),
    data: { seo: flowRouteSeo.preguntasBancamia, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-bancow',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-bancow/preguntas-bancow.module').then(
        (m) => m.PreguntasBancowModule,
      ),
    data: { seo: flowRouteSeo.preguntasBancow, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-coltefinanciera',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-coltefinanciera/preguntas-coltefinanciera.module').then(
        (m) => m.PreguntasColtefinancieraModule,
      ),
    data: {
      seo: flowRouteSeo.preguntasColtefinanciera,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'v2/preguntas-iris',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-dannregional/preguntas-dannregional.module').then(
        (m) => m.PreguntasDannregionalModule,
      ),
    data: { seo: flowRouteSeo.preguntasIris, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas/coltefinanciera/flamingo',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-flamingo/preguntas-flamingo.module').then(
        (m) => m.PreguntasFlamingoModule,
      ),
    data: { seo: flowRouteSeo.preguntasFlamingo, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-mibanco',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-mibanco/preguntas-mibanco.module').then(
        (m) => m.PreguntasMibancoModule,
      ),
    data: { seo: flowRouteSeo.preguntasMibanco, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-bancomundomujer',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-mundomujer/preguntas-mundomujer.module').then(
        (m) => m.PreguntasMundomujerModule,
      ),
    data: { seo: flowRouteSeo.preguntasMundoMujer, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-credifamilia',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-credifamilia/preguntas-credifamilia.module').then(
        (m) => m.PreguntasCredifamiliaModule,
      ),
    data: { seo: flowRouteSeo.preguntasCredifamilia, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-cdturbo',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-cdturbo/preguntas-cdturbo.module').then(
        (m) => m.PreguntasCdturboModule,
      ),
    data: { seo: flowRouteSeo.preguntasCdturbo, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-koa',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-koa/preguntas-koa.module').then((m) => m.PreguntasKoaModule),
    data: { seo: flowRouteSeo.preguntasKoa, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'v2/preguntas-bancounion',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/formulario-nativo/preguntas-bancounion/preguntas-bancounion.component').then(
        (m) => m.PreguntasBancounionComponent,
      ),
    data: { seo: flowRouteSeo.preguntasBancounion, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
];

const routes_aperture: Routes = [
  {
    path: 'confirma-tus-datos',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/confirma-tus-datos/confirma-tus-datos.module').then((m) => m.ConfirmaTusDatosModule),
    data: { seo: flowRouteSeo.confirmaTusDatos, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'bienvenida-usuario-retorno',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/bienvenida-usuario-retorno/bienvenida-usuario-retorno.module').then(
        (m) => m.WelcomeReturningUserModule,
      ),
    data: {
      seo: flowRouteSeo.bienvenidaUsuarioRetorno,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'validar-identidad',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/validar-identidad/validar-identidad.module').then((m) => m.ValidarIdentidadModule),
    data: {
      seo: flowRouteSeo.validarIdentidad,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
      processStep: 'identity',
    },
  },
  {
    path: 'confirmar-datos-truora',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/confirmar-datos-truora/confirmar-datos-truora.module').then((m) => m.ConfirmarDatosTruoraModule),
    data: { seo: flowRouteSeo.confirmarDatosTruora, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'continuar-proceso',
    canActivate: PROCESS_AUTH_GUARDS,
    loadChildren: () =>
      import('./routes/continuar-proceso/continuar-proceso.module').then((m) => m.ContinuarProcesoModule),
    data: { seo: flowRouteSeo.continuarProceso },
  },
  {
    path: 'consulta-en-listas',
    canActivate: PROCESS_AUTH_GUARDS,
    loadChildren: () =>
      import('./routes/consulta-en-listas/consulta-en-listas.module').then((m) => m.ConsultaEnListasModule),
    data: { seo: flowRouteSeo.consultaEnListas },
  },
  {
    path: 'sube-tus-documentos',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/sube-tus-documentos-v2/sube-tus-documentos-v2.module').then((m) => m.SubeTusDocumentosV2Module),
    data: {
      seo: flowRouteSeo.subeTusDocumentos,
      requireActiveProcess: true,
      expectedStatuses: DOCUMENT_UPLOAD_STATUSES,
    },
  },
  {
    path: 'asegura-tu-tasa',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () => import('./routes/asegura-tu-tasa/asegura-tu-tasa.module').then((m) => m.AseguraTuTasaModule),
    data: { seo: flowRouteSeo.aseguraTuTasa, requireActiveProcess: true, expectedStatuses: SIGNING_STATUSES },
  },
  {
    path: 'transfiere-el-dinero',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/magical-experience/transfiere-el-dinero/transfiere-el-dinero.component').then(
        (m) => m.TransfiereElDineroComponent,
      ),
    data: { seo: flowRouteSeo.transfiereElDinero, requireActiveProcess: true, expectedStatuses: DEPOSIT_STATUSES },
  },
  {
    path: 'cdt-completado',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/magical-experience/cdt-completado/cdt-completado.component').then(
        (m) => m.CdtCompletadoComponent,
      ),
    data: { seo: flowRouteSeo.cdtCompletado, requireActiveProcess: true, expectedStatuses: COMPLETED_STATUSES },
  },
  {
    path: 'sube-el-comprobante-de-pago',
    redirectTo: '/transfiere-el-dinero',
  },
  {
    path: 'firma-los-documentos',
    redirectTo: '/asegura-tu-tasa',
  },
];

const CDTInfluencers = () => import('./routes/cdt-influencer/cdt-influencer.module').then((m) => m.CdtInfluencerModule);
const routes_cdt_influencers: Routes = [
  {
    path: 'cdt-claudiauribe',
    loadChildren: () =>
      import('./routes/cdt-claudiauribe/cdt-claudiauribe.module').then((m) => m.CdtClaudiauribeModule),
  },
  { path: 'cdt-nicolasabril', loadChildren: CDTInfluencers },
  { path: 'cdt-financiatuvida', loadChildren: CDTInfluencers },
  { path: 'cdt-parejayfinanzas', loadChildren: CDTInfluencers },
  { path: 'cdt-alternativainversiones', loadChildren: CDTInfluencers },
  { path: 'cdt-arenalfa', loadChildren: CDTInfluencers },
  { path: 'cdt-notidanny', loadChildren: CDTInfluencers },
  { path: 'cdt-academiadelexito', loadChildren: CDTInfluencers },
  { path: 'cdt-sebasirreverente', loadChildren: CDTInfluencers },
  { path: 'cdt-tian', loadChildren: CDTInfluencers },
  { path: 'cdt-sebascelis', loadChildren: CDTInfluencers },
  { path: 'cdt-planeacionfinancieracolombia', loadChildren: CDTInfluencers },
  { path: 'cdt-entrenadorfinanciero', loadChildren: CDTInfluencers },
  { path: 'cdt-davidlozano', loadChildren: CDTInfluencers },
  { path: 'cdt-santiagoelberriondo', loadChildren: CDTInfluencers },
];

const CDTBanksComponentLoader = () =>
  import('./routes/cdt-banco-v2/cdt-banco-v2.component').then((m) => m.CdtBancoV2Component);
const routes_cdt_banks_component: Routes = [
  { path: 'cdt-agrario', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-coltefinanciera', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-pichincha', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-credifinanciera', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-ban100', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-ibrcredifinanciera', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-bancamia', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-bancolombia', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-bogota', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-popular', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-itau', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-gnbsudameris', redirectTo: '/cdt-simulador' },
  { path: 'cdt-sudameris', redirectTo: '/cdt-simulador' },
  { path: 'cdt-bbva', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-occidente', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-cajasocial', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-davivienda', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-avvillas', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-bancow', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-bancoomeva', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-bancounion', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-finandina', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-falabella', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-coopcentral', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-mundomujer', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-serfinanza', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-davibank', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-mibanco', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-iris', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-credifamilia', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-koa', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-bold', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-nu', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-contactar', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-santander', loadComponent: CDTBanksComponentLoader },
  { path: 'cdt-lulo', loadComponent: CDTBanksComponentLoader },
];

/* Mejores CDT del Mes — standalone + loadComponent (no NgModule) */
const loadMejoresCdtMesComponent = () =>
  import('./routes/mejores-cdt-mes-v2/mejores-cdt-mes-v2.component').then((m) => m.MejoresCdtMesV2Component);

const routes_best_banks_month: Routes = getBestCdtMonthRoutes(loadMejoresCdtMesComponent);

const path_best_current_cdt = routes_best_banks_month[0]?.path ?? '/404';

const routes_best_banks_month_old: Routes = getOldBestCdtMonthRoutes(path_best_current_cdt);

/* Mejores CDT del Mes */
/* const MejoresCDTsMesModuleLoader = () =>
  import('./routes/mejores-cdt-mes/mejores-cdt-mes.module').then((m) => m.MejoresCdtMesModule); 

const routes_best_banks_month: Routes = getBestCdtMonthRoutes(MejoresCDTsMesModuleLoader);

const path_best_current_cdt = routes_best_banks_month[0]?.path ?? '/404';

const routes_best_banks_month_old: Routes = getOldBestCdtMonthRoutes(path_best_current_cdt); */

/* Blog */
const blogElementModuleLoader = () =>
  import('./routes/blog-element/blog-element.module').then((m) => m.BlogElementModule);

const blog: Routes = [
  { path: 'blog/categorias', loadChildren: () => import('./routes/blog/blog.module').then((m) => m.BlogModule) },
  { path: 'blog/categoria/:id', loadChildren: () => import('./routes/blog/blog.module').then((m) => m.BlogModule) },
  /* Sobre nosotros */
  { path: 'indice-de-arrepentimiento-financiero-2025', redirectTo: 'guias-para-maximizar-tu-dinero-con-los-cdt' },
  { path: 'politica-de-privacidad', loadChildren: blogElementModuleLoader },
  /* Libro gratuito */
  { path: 'psicologia-de-las-inversiones', loadChildren: blogElementModuleLoader },
  { path: 'tecnicas-y-estrategias-para-ahorrar-e-invertir', loadChildren: blogElementModuleLoader },
  { path: 'de-la-planificacion-a-la-accion', loadChildren: blogElementModuleLoader },
  { path: 'mis-mejores-cdts', loadChildren: blogElementModuleLoader },
  { path: 'todo-lo-que-debes-saber-de-los-cdt', loadChildren: blogElementModuleLoader },
  /* Servicios de mejorCDT */
  /* { path: 'cdt-recargable', loadChildren: blogElementModuleLoader }, */
  { path: 'cdt-recargable', redirectTo: '/cdt-simulador' },
  { path: 'retira-tu-cdt-ante-una-emergencia', loadChildren: blogElementModuleLoader },
  {
    path: 'cdt-flexible',
    loadChildren: () => import('./routes/cdt-flexible/cdt-flexible.module').then((m) => m.CdtFlexibleModule),
  },
  /* {
    path: 'cdt-flexible',
    redirectTo: '/cdt-simulador',
  }, */
  /* Sobre los CDTS */
  { path: 'un-cdt-hace-pagar-mas-impuestos', loadChildren: blogElementModuleLoader },
  { path: 'los-colombianos-se-arrepiente-de-como-usa-su-prima', loadChildren: blogElementModuleLoader },
  { path: 'el-costo-invisible-de-esperar-para-invertir', loadChildren: blogElementModuleLoader },
  {
    path: 'el-error-mas-comun-al-invertir-en-cdt-y-la-formula-para-elegir-el-mejor-en-tiempos-de-tasas-altas',
    loadChildren: blogElementModuleLoader,
  },
  { path: 'subida-de-tasas-en-colombia', loadChildren: blogElementModuleLoader },
  { path: 'por-que-el-cdt-de-bold-esta-dando-de-que-hablar', loadChildren: blogElementModuleLoader },
  { path: 'como-invertir-tu-prima-en-el-mejorcdt-en-colombia-2025', loadChildren: blogElementModuleLoader },
  { path: 'nubank-ofrece-cdt-en-el-2025', loadChildren: blogElementModuleLoader },
  { path: 'cual-es-el-monto-minimo-para-invertir-en-un-cdt-en-colombia', loadChildren: blogElementModuleLoader },
  { path: 'cdt-nubank', loadChildren: blogElementModuleLoader },
  { path: 'cdt-para-empresas', loadChildren: blogElementModuleLoader },
  { path: 'cdt-vs-inflacion', loadChildren: blogElementModuleLoader },
  { path: 'como-calcular-los-intereses-de-un-cdt', loadChildren: blogElementModuleLoader },
  { path: 'como-funciona-un-cdt-en-colombia', loadChildren: blogElementModuleLoader },
  { path: 'cuales-son-los-diferentes-usos-de-un-cdt', loadChildren: blogElementModuleLoader },
  { path: 'cuanto-paga-un-cdt', loadChildren: blogElementModuleLoader },
  { path: 'historia-de-los-cdts', loadChildren: blogElementModuleLoader },
  { path: 'por-que-el-banco-me-pide-tantos-documentos-para-abrir-mi-cdt', loadChildren: blogElementModuleLoader },
  { path: 'por-que-invertir-en-un-cdt', redirectTo: 'por-que-cdt' },
  { path: 'por-que-cdt', loadChildren: blogElementModuleLoader },
  { path: 'que-bancos-tienen-cdt-en-colombia', loadChildren: blogElementModuleLoader },
  { path: 'que-es-un-cdt', loadChildren: blogElementModuleLoader },
  { path: 'se-puede-retirar-el-dinero-de-tu-cdt-antes-del-vencimiento', loadChildren: blogElementModuleLoader },
  { path: 'tipos-beneficios-y-requisitos-para-un-cdt', loadChildren: blogElementModuleLoader },
  { path: 'un-menor-de-edad-puede-abrir-un-cdt', loadChildren: blogElementModuleLoader },
  { path: 'ventajas-de-un-cdt-como-inversion', loadChildren: blogElementModuleLoader },
  {
    path: 'los-saldos-de-los-cdts-siguen-creciendo-en-2024-y-aqui-te-contamos-por-que',
    loadChildren: blogElementModuleLoader,
  },
  {
    path: 'recomendaciones-para-hacer-transacciones-financieras-digitales-seguras',
    loadChildren: blogElementModuleLoader,
  },
  { path: 'por-que-invertir-en-un-cdt-aprende-a-hacer-crecer-tu-dinero', loadChildren: blogElementModuleLoader },
  { path: 'que-banco-paga-mejor-cdt-hoy', loadChildren: blogElementModuleLoader },
  /* Sobre tus finanzas */
  { path: 'inversiones-seguras', loadChildren: blogElementModuleLoader },
  { path: 'cdts-o-invertir-en-dolares-bitcon-o-acciones', loadChildren: blogElementModuleLoader },
  { path: 'radar-financiero', loadChildren: blogElementModuleLoader },
  { path: 'claves-para-ahorrar-en-un-fondo-de-emergencia', loadChildren: blogElementModuleLoader },
  {
    path: 'como-han-cambiado-los-bancos-de-nombre-a-lo-largo-de-la-historia-de-colombia',
    loadChildren: blogElementModuleLoader,
  },
  { path: 'consejos-padre-exito-financiero-hijos', loadChildren: blogElementModuleLoader },
  { path: 'consejos-para-maximizar-tus-ganancias-segun-el-ciclo-economico', loadChildren: blogElementModuleLoader },
  { path: 'mitos-y-verdades-de-la-declaracion-de-renta-de-los-cdts', loadChildren: blogElementModuleLoader },
  { path: 'mitos-y-verdades-sobre-la-retencion-en-la-fuente', loadChildren: blogElementModuleLoader },
  { path: 'que-es-fogafin', loadChildren: blogElementModuleLoader },
  { path: 'que-es-un-fondo-de-emergencia', loadChildren: blogElementModuleLoader },
  { path: 'que-es-una-calificacion-de-riesgo', loadChildren: blogElementModuleLoader },
  { path: 'sillicon-valley-bank-seguro-financiero', loadChildren: blogElementModuleLoader },
  { path: 'todo-lo-que-debes-saber-sobre-deceval', loadChildren: blogElementModuleLoader },
  { path: 'todo-lo-que-debes-saber-sobre-el-impuesto-4x1-000-en-colombia', loadChildren: blogElementModuleLoader },
  { path: 'guia-para-inversionistas-en-cdt-declaracion-renta-simplificada', loadChildren: blogElementModuleLoader },
  { path: 'analfabetismo-financiero', loadChildren: blogElementModuleLoader },
  /* Novedades de los CDT */
  { path: 'como-entender-la-economia-colombiana-mas-alla-del-ruido', loadChildren: blogElementModuleLoader },
  {
    path: 'subida-de-tasas-del-banco-de-la-republica-por-que-este-es-el-mejor-momento-para-invertir-en-cdt-en-2026',
    loadChildren: blogElementModuleLoader,
  },
  {
    path: 'el-impacto-de-las-tasas-de-interes-del-banco-de-la-republica-en-los-cdts',
    loadChildren: blogElementModuleLoader,
  },
  { path: 'como-se-comportan-los-cdt-en-colombia-vs-en-el-mundo', loadChildren: blogElementModuleLoader },
  { path: 'en-la-renovacion-de-un-cdt-debo-pagar-el-4x1000', loadChildren: blogElementModuleLoader },
  { path: 'es-tu-momento-para-invertir', loadChildren: blogElementModuleLoader },
  { path: 'historico-de-las-tasas-de-los-cdt-a-traves-de-los-anos', loadChildren: blogElementModuleLoader },
  { path: 'las-tasas-de-los-cdt-han-subido', loadChildren: blogElementModuleLoader },
  { path: 'solo-3-de-cada-100-personas-tienen-un-cdt', loadChildren: blogElementModuleLoader },
  { path: 'es-tu-momento-para-invertir', loadChildren: blogElementModuleLoader },
  { path: 'por-que-hay-unos-cdt-mas-rentables-que-otros', loadChildren: blogElementModuleLoader },
  { path: 'por-que-las-tasas-de-los-cdt-bajaron', loadChildren: blogElementModuleLoader },
  { path: 'cdt-vs-cuentas-de-ahorro-de-alto-rendimiento', loadChildren: blogElementModuleLoader },
  {
    path: 'cuentas-de-alto-rendimiento-vs-cdt-descubre-cual-es-la-mejor-opcion-para-ti',
    loadChildren: blogElementModuleLoader,
  },
  /* Cuentas de ahorros vs CDT */
  {
    path: 'tasas-porcentuales-de-cuentas-de-ahorro-de-alto-rendimiento-y-beneficios-de-cdt',
    loadChildren: blogElementModuleLoader,
  },
];

const routes_alerts_components: Routes = [
  {
    path: 'no-podemos-continuar-con-tu-proceso',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/no-podemos-continuar-con-tu-proceso/no-podemos-continuar-con-tu-proceso.module').then(
        (m) => m.NoPodemosContinuarConTuProcesoModule,
      ),
    data: {
      seo: flowRouteSeo.noPodemosContinuar,
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-hard-block'],
    },
  },
  {
    path: 'firma-los-documentos-en-fisico',
    canActivate: PROCESS_AUTH_GUARDS,
    loadChildren: () =>
      import('./routes/no-podemos-continuar-con-tu-proceso/no-podemos-continuar-con-tu-proceso.module').then(
        (m) => m.NoPodemosContinuarConTuProcesoModule,
      ),
    data: { seo: flowRouteSeo.firmaDocumentosFisico },
  },
  {
    path: 'bloqueo-temporal',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/bloqueo-temporal/bloqueo-temporal.module').then((m) => m.BloqueoTemporalModule),
    data: {
      seo: flowRouteSeo.bloqueoTemporal,
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-temporary-block'],
    },
  },
  {
    path: 'te-contactaremos',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/te-contactaremos/te-contactaremos.module').then((m) => m.TeContactaremosModule),
    data: {
      seo: flowRouteSeo.teContactaremos,
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-contact'],
    },
  },
];

const routes_landings_pages: Routes = [
  {
    path: 'juntos-podemos-ayudar',
    loadComponent: () =>
      import('./routes/juntos-podemos-ayudar/juntos-podemos-ayudar.component').then(
        (m) => m.JuntosPodemosAyudarComponent,
      ),
  },
  {
    path: 'ponle-nombre-a-tu-ahorro',
    loadComponent: () =>
      import('./routes/ponle-nombre-a-tu-ahorro/ponle-nombre-a-tu-ahorro.component').then(
        (m) => m.PonleNombreATuAhorroComponent,
      ),
  },
  {
    path: 'antes-de-renovar-el-cdt-compara-el-mercado',
    loadComponent: () =>
      import('./routes/antes-de-renovar-el-cdt-compara-el-mercado/antes-de-renovar-el-cdt-compara-el-mercado.component').then(
        (m) => m.AntesDeRenovarElCdtComparaElMercadoComponent,
      ),
  },
  {
    path: 'nueva-app',
    loadComponent: () => import('./routes/nueva-app/nueva-app.component').then((m) => m.NuevaAppComponent),
    data: {
      seo: {
        title: 'Nueva app | MejorCDT',
        description:
          'Descubre una forma más ágil y clara de gestionar tus inversiones desde tu celular con la nueva app de MejorCDT.',
        keywords: 'app MejorCDT, inversiones, CDT, gestionar CDT, panorama financiero, aplicación MejorCDT',
        articleSection: 'Aplicación MejorCDT',
      },
    },
  },
  {
    path: 'cdt-midatacredito',
    loadComponent: () =>
      import('./routes/mi-datacredito/mi-datacredito.component').then((m) => m.MiDatacreditoComponent),
  },
  {
    path: 'mundial-de-tejo-2025',
    loadComponent: () =>
      import('./routes/mundial-de-tejo-2025/mundial-de-tejo-2025.component').then((m) => m.MundialDeTejo2025Component),
  },
  {
    path: 'finverzo-2025',
    loadComponent: () => import('./routes/finverzo-2025/finverzo-2025.component').then((m) => m.Finverzo2025Component),
  },
  {
    path: 'circombia',
    loadComponent: () => import('./routes/circombia/circombia.component').then((m) => m.CircombiaComponent),
  },
  {
    path: 'moneymastery-2025',
    loadComponent: () =>
      import('./routes/moneymonastery-2025/moneymonastery-2025.component').then((m) => m.Moneymonastery2025Component),
  },
  {
    path: 'fintrust-2025',
    loadComponent: () => import('./routes/fintrust-2025/fintrust-2025.component').then((m) => m.Fintrust2025Component),
  },
  {
    path: 'yo-me-llamo-cdt',
    loadComponent: () =>
      import('./routes/yo-me-llamo-cdt/yo-me-llamo-cdt.component').then((m) => m.YoMeLlamoCdtComponent),
  },
  {
    path: 'cdt-para-empresas-en-colombia',
    loadChildren: () =>
      import('./routes/cdt-para-empresas/cdt-para-empresas.module').then((m) => m.CdtParaEmpresasModule),
  },
  {
    path: 'a-unos-minutos-de-abrir-tu-cdt',
    loadChildren: () =>
      import('./routes/a-unos-minutos-de-abrir-tu-cdt/a-unos-minutos-de-abrir-tu-cdt.module').then(
        (m) => m.AUnosMinutosDeAbrirTuCdtModule,
      ),
  },
  {
    path: 'credifinanciera-es-ban-100',
    loadChildren: () =>
      import('./routes/credifinanciera-es-ban-100/credifinanciera-es-ban-100.module').then(
        (m) => m.CredifinancieraEsBan100Module,
      ),
  },
  {
    path: 'preguntas-frecuentes',
    loadChildren: () =>
      import('./routes/preguntas-frecuentes/preguntas-frecuentes.module').then((m) => m.PreguntasFrecuentesModule),
  },
  {
    path: 'libro-gratuito',
    loadChildren: () => import('./routes/libro-gratuito/libro-gratuito.module').then((m) => m.LibroGratuitoModule),
  },
  {
    path: 'guias-para-maximizar-tu-dinero-con-los-cdt',
    loadChildren: () =>
      import('./routes/guias-para-maximizar-tu-dinero-con-los-cdt/guias-para-maximizar-tu-dinero-con-los-cdt.module').then(
        (m) => m.GuiasParaMaximizarTuDineroConLosCdtModule,
      ),
  },
  { path: 'e-book', redirectTo: '/libro-gratuito' },
  {
    path: 'pioneros-finanzas-emocionales',
    loadChildren: () =>
      import('./routes/pioneros-finanzas-emocionales/pioneros-finanzas-emocionales.module').then(
        (m) => m.PionerosFinanzasEmocionalesModule,
      ),
  },
  {
    path: 'life-miles',
    loadChildren: () => import('./routes/life-miles/life-miles.module').then((m) => m.LifeMilesModule),
  },
  {
    path: 'jumbo-cdt',
    loadChildren: () => import('./routes/jumbo-cdt/jumbo-cdt.module').then((m) => m.JumboCdtModule),
  },
  {
    path: 'promos/volvieron-las-tasas-del-15-de-rentabilidad',
    redirectTo: '/dias-azules',
  },
  {
    path: 'dias-azules',
    loadChildren: () => import('./routes/dias-azules/dias-azules.module').then((m) => m.DiasAzulesModule),
  },
  {
    path: 'beneficios-ban100',
    loadChildren: () =>
      import('./routes/beneficios-ban100/beneficios-ban100.module').then((m) => m.BeneficiosBan100Module),
  },
  {
    path: 'trabajo',
    loadChildren: () => import('./routes/trabajo/trabajo.module').then((m) => m.TrabajoModule),
  },
  {
    path: 'prensa',
    loadChildren: () => import('./routes/prensa/prensa.module').then((m) => m.PrensaModule),
  },
  {
    path: 'golf18',
    loadChildren: () => import('./routes/evento-golf18/evento-golf18.module').then((m) => m.EventoGolf18Module),
  },
  {
    path: 'sueldo-inteligente',
    loadChildren: () =>
      import('./routes/sueldo-inteligente/sueldo-inteligente.module').then((m) => m.SueldoInteligenteModule),
  },
  {
    path: 'moneycon',
    loadChildren: () => import('./routes/moneycon/moneycon.module').then((m) => m.MoneyconModule),
  },
  {
    path: 'te-esperamos-en-la-moneycon',
    loadChildren: () =>
      import('./routes/te-esperamos-en-la-moneycon/te-esperamos-en-la-moneycon.module').then(
        (m) => m.TeEsperamosEnLaMoneyconModule,
      ),
  },
  {
    path: 'retirar-cdt-antes-de-tiempo-es-posible-con-mejorcdt',
    loadChildren: () => import('./routes/compra-venta-cdt/compra-venta-cdt.module').then((m) => m.CompraVentaCdtModule),
  },
  /* {
    path: 'retirar-cdt-antes-de-tiempo-es-posible-con-mejorcdt',
    redirectTo: '/cdt-simulador',
  }, */
  {
    path: 'valora-analitik',
    loadChildren: () => import('./routes/valora-analitik/valora-analitik.module').then((m) => m.ValoraAnalitikModule),
  },
  {
    path: 'rmkt/retirar-hasta-10-millones-de-tu-cdt-gratis',
    redirectTo: 'cdt-flexible-retiro-gratis',
  },
  {
    path: 'cdt-flexible-retiro-gratis',
    loadComponent: () =>
      import('./routes/remarketing/retirar-hasta-10-millones-de-tu-cdt-gratis/retirar-hasta-10-millones-de-tu-cdt-gratis.component').then(
        (m) => m.RetirarHasta10MillonesDeTuCdtGratisComponent,
      ),
  },
  {
    path: 'asesoria-gratis-cdt',
    loadComponent: () =>
      import('./routes/remarketing/recibe-asesoria-gratis/recibe-asesoria-gratis.component').then(
        (m) => m.RecibeAsesoriaGratisComponent,
      ),
  },
  {
    path: 'desde-nuestra-plataforma-puedes-abrir-tu-cdt-gratis-completamente-digital',
    loadComponent: () =>
      import('./routes/remarketing/pautasem-2025/pautasem-2025.component').then((m) => m.Pautasem2025Component),
  },
  {
    path: 'gofest',
    loadChildren: () => import('./routes/gofest/gofest.module').then((m) => m.GofestModule),
  },
  {
    path: 'poderosas2025',
    loadChildren: () => import('./routes/poderosas2025/poderosas2025.module').then((m) => m.Poderosas2025Module),
  },
];

const widgets_frame: Routes = [
  {
    path: 'widget-simulador',
    loadChildren: () =>
      import('./resources-widget/widget-frame-simulador/widget-frame-simulador.module').then(
        (m) => m.WidgetFrameSimuladorModule,
      ),
  },
];

const relevant_301_redirect: Routes = [
  {
    path: 'ab-testing/cdt-simulador',
    redirectTo: '/cdt-simulador',
  },
];

const routes_home: Routes = [
  /* {
    path: '',
    loadComponent: () => import('./routes/home-refactor/home-refactor.component').then((m) => m.HomeRefactorComponent),
  }, */
  {
    path: '',
    loadComponent: () => import('./routes/home-v2/home-v2.component').then((m) => m.HomeV2Component),
  },
];

const route_home_refactor: Routes = [
  {
    path: 'home-refactor',
    loadComponent: () => import('./routes/home-refactor/home-refactor.component').then((m) => m.HomeRefactorComponent),
  },
];

const routes_404: Routes = [
  {
    path: '404',
    loadChildren: () => import('./routes/pagina-404/pagina-404.module').then((m) => m.Pagina404Module),
  },
  {
    path: '**', // Ruta comodín para redirección
    redirectTo: '/404', // Redirige a la ruta principal (home) si la ruta no coincide con ninguna otra definida
  },
];

const magical_experience_flow: Routes = [
  {
    path: 'magical_experience/confirma-tus-datos',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/confirma-tus-datos/confirma-tus-datos.module').then((m) => m.ConfirmaTusDatosModule),
    data: { seo: flowRouteSeo.confirmaTusDatos, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/bienvenida-usuario-retorno',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/bienvenida-usuario-retorno/bienvenida-usuario-retorno.module').then(
        (m) => m.WelcomeReturningUserModule,
      ),
    data: {
      seo: flowRouteSeo.bienvenidaUsuarioRetorno,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'magical_experience/validar-identidad',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/validar-identidad/validar-identidad.module').then((m) => m.ValidarIdentidadModule),
    data: {
      seo: flowRouteSeo.validarIdentidad,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
      processStep: 'identity',
    },
  },
  {
    path: 'magical_experience/confirmar-datos-truora',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/confirmar-datos-truora/confirmar-datos-truora.module').then((m) => m.ConfirmarDatosTruoraModule),
    data: { seo: flowRouteSeo.confirmarDatosTruora, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/continuar-proceso',
    canActivate: PROCESS_AUTH_GUARDS,
    loadChildren: () =>
      import('./routes/continuar-proceso/continuar-proceso.module').then((m) => m.ContinuarProcesoModule),
    data: { seo: flowRouteSeo.continuarProceso },
  },
  {
    path: 'magical_experience/consulta-en-listas',
    canActivate: PROCESS_AUTH_GUARDS,
    loadComponent: () =>
      import('./routes/magical-experience/consulta-en-listas/consulta-en-listas.component').then(
        (m) => m.ConsultaEnListasComponent,
      ),
    data: { seo: flowRouteSeo.consultaEnListas },
  },
  {
    path: 'magical_experience/validacion-interna-proceso',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/process-restrictions/internal-validation/internal-validation.component').then(
        (m) => m.InternalValidationComponent,
      ),
    data: {
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-waiting'],
    },
  },
  {
    path: 'magical_experience/informacion-en-revision',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/process-restrictions/restricted-information/restricted-information.component').then(
        (m) => m.RestrictedInformationComponent,
      ),
    data: {
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-blocked'],
    },
  },
  {
    path: 'magical_experience/sube-tus-documentos',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/sube-tus-documentos-v2/sube-tus-documentos-v2.module').then((m) => m.SubeTusDocumentosV2Module),
    data: {
      seo: flowRouteSeo.subeTusDocumentos,
      requireActiveProcess: true,
      expectedStatuses: DOCUMENT_UPLOAD_STATUSES,
    },
  },
  {
    path: 'magical_experience/asegura-tu-tasa',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () => import('./routes/asegura-tu-tasa/asegura-tu-tasa.module').then((m) => m.AseguraTuTasaModule),
    data: { seo: flowRouteSeo.aseguraTuTasa, requireActiveProcess: true, expectedStatuses: SIGNING_STATUSES },
  },
  {
    path: 'magical_experience/transfiere-el-dinero',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/magical-experience/transfiere-el-dinero/transfiere-el-dinero.component').then(
        (m) => m.TransfiereElDineroComponent,
      ),
    data: {
      seo: flowRouteSeo.transfiereElDinero,
      requireActiveProcess: true,
      expectedStatuses: DEPOSIT_STATUSES,
      requireMagicalExperience: true,
    },
  },
  {
    path: 'magical_experience/cdt-completado',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/magical-experience/cdt-completado/cdt-completado.component').then(
        (m) => m.CdtCompletadoComponent,
      ),
    data: { seo: flowRouteSeo.cdtCompletado, requireActiveProcess: true, expectedStatuses: COMPLETED_STATUSES },
  },
  {
    path: 'magical_experience/sube-el-comprobante-de-pago',
    redirectTo: '/magical_experience/transfiere-el-dinero',
  },
  {
    path: 'magical_experience/firma-los-documentos',
    redirectTo: '/magical_experience/asegura-tu-tasa',
  },
  {
    path: 'magical_experience/no-podemos-continuar-con-tu-proceso',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/no-podemos-continuar-con-tu-proceso/no-podemos-continuar-con-tu-proceso.module').then(
        (m) => m.NoPodemosContinuarConTuProcesoModule,
      ),
    data: {
      seo: flowRouteSeo.noPodemosContinuar,
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-hard-block'],
    },
  },
  {
    path: 'magical_experience/firma-los-documentos-en-fisico',
    canActivate: PROCESS_AUTH_GUARDS,
    loadChildren: () =>
      import('./routes/no-podemos-continuar-con-tu-proceso/no-podemos-continuar-con-tu-proceso.module').then(
        (m) => m.NoPodemosContinuarConTuProcesoModule,
      ),
    data: { seo: flowRouteSeo.firmaDocumentosFisico },
  },
  {
    path: 'magical_experience/bloqueo-temporal',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/bloqueo-temporal/bloqueo-temporal.module').then((m) => m.BloqueoTemporalModule),
    data: {
      seo: flowRouteSeo.bloqueoTemporal,
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-temporary-block'],
    },
  },
  {
    path: 'magical_experience/te-contactaremos',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/te-contactaremos/te-contactaremos.module').then((m) => m.TeContactaremosModule),
    data: {
      seo: flowRouteSeo.teContactaremos,
      requireActiveProcess: true,
      allowedDecisionTypes: ['redirect-to-contact'],
    },
  },
  {
    path: 'magical_experience/cuentanos-sobre-ti',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/magical-experience/formulario/magical-experience.component').then(
        (m) => m.MagicalExperienceComponent,
      ),
    data: { seo: flowRouteSeo.cuentanosSobreTi, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/datos-personales',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/datos-personales/datos-personales.module').then(
        (m) => m.DatosPersonalesModule,
      ),
    data: {
      onSameUrlNavigation: 'reload',
      seo: flowRouteSeo.datosPersonales,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'magical_experience/v2/datos-financieros',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/datos-financieros/datos-financieros.module').then(
        (m) => m.DatosFinancierosModule,
      ),
    data: {
      onSameUrlNavigation: 'reload',
      seo: flowRouteSeo.datosFinancieros,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'magical_experience/v2/preguntas-ban100',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-ban100/preguntas-ban100.module').then(
        (m) => m.PreguntasBan100Module,
      ),
    data: { seo: flowRouteSeo.preguntasBan100, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-bancamia',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-bancamia/preguntas-bancamia.module').then(
        (m) => m.PreguntasBancamiaModule,
      ),
    data: { seo: flowRouteSeo.preguntasBancamia, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-bancow',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-bancow/preguntas-bancow.module').then(
        (m) => m.PreguntasBancowModule,
      ),
    data: { seo: flowRouteSeo.preguntasBancow, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-coltefinanciera',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-coltefinanciera/preguntas-coltefinanciera.module').then(
        (m) => m.PreguntasColtefinancieraModule,
      ),
    data: {
      seo: flowRouteSeo.preguntasColtefinanciera,
      requireActiveProcess: true,
      expectedStatuses: LEAD_FORM_STATUSES,
    },
  },
  {
    path: 'magical_experience/v2/preguntas-iris',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-dannregional/preguntas-dannregional.module').then(
        (m) => m.PreguntasDannregionalModule,
      ),
    data: { seo: flowRouteSeo.preguntasIris, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas/coltefinanciera/flamingo',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-flamingo/preguntas-flamingo.module').then(
        (m) => m.PreguntasFlamingoModule,
      ),
    data: { seo: flowRouteSeo.preguntasFlamingo, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-mibanco',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-mibanco/preguntas-mibanco.module').then(
        (m) => m.PreguntasMibancoModule,
      ),
    data: { seo: flowRouteSeo.preguntasMibanco, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-bancomundomujer',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-mundomujer/preguntas-mundomujer.module').then(
        (m) => m.PreguntasMundomujerModule,
      ),
    data: { seo: flowRouteSeo.preguntasMundoMujer, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-credifamilia',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-credifamilia/preguntas-credifamilia.module').then(
        (m) => m.PreguntasCredifamiliaModule,
      ),
    data: { seo: flowRouteSeo.preguntasCredifamilia, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-cdturbo',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-cdturbo/preguntas-cdturbo.module').then(
        (m) => m.PreguntasCdturboModule,
      ),
    data: { seo: flowRouteSeo.preguntasCdturbo, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-koa',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadChildren: () =>
      import('./routes/formulario-nativo/preguntas-koa/preguntas-koa.module').then((m) => m.PreguntasKoaModule),
    data: { seo: flowRouteSeo.preguntasKoa, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
  {
    path: 'magical_experience/v2/preguntas-bancounion',
    canActivate: PROCESS_ROUTE_GUARDS,
    loadComponent: () =>
      import('./routes/formulario-nativo/preguntas-bancounion/preguntas-bancounion.component').then(
        (m) => m.PreguntasBancounionComponent,
      ),
    data: { seo: flowRouteSeo.preguntasBancounion, requireActiveProcess: true, expectedStatuses: LEAD_FORM_STATUSES },
  },
];

const brandRoutesMap: { [key: string]: Routes } = {
  coltefinanciera: routingColtefinanciera.routes,
  default: [
    // Isolated route to prevent interference with path ''
    ...route_home_refactor,
    ...routes_home,
    ...routes_app,
    ...routes_form_sdk_tripetto,
    ...routes_form_v2,
    ...routes_aperture,
    ...routes_cdt_banks_component,
    ...routes_cdt_influencers,
    ...routes_ab_testing,
    ...routes_campaign_mejorcdt,
    ...routes_best_banks_month,
    ...routes_best_banks_month_old,
    ...blog,
    ...routes_alerts_components,
    ...routes_landings_pages,
    ...widgets_frame,
    ...relevant_301_redirect,
    ...magical_experience_flow,
    ...routes_404,
  ],
};

const selectedRoutes = brandRoutesMap[environment.BRAND] || brandRoutesMap.default;

/** Exportado para que el servidor (server-sitemap.ts) enumere las rutas reales y autogenere sitemap/robots. */
export const routes: Routes = selectedRoutes;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading, // Desactiva completamente el preloading para debug
      enableTracing: false, // Desactiva el tracing para mejor performance
      initialNavigation: 'enabledNonBlocking', // Permite renderizar el overlay global antes de resolver guards
      scrollPositionRestoration: 'top', // Optimiza el scroll
      onSameUrlNavigation: 'reload', // Mejora la navegación en misma URL
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
